var React = require('react');

function Inbox (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"f comment"),React.createElement("g",{"className":"nc-icon-wrapper","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","fill":"#000000","stroke":"#000000","key":1},[React.createElement("path",{"fill":"none","stroke":"#000000","strokeMiterlimit":"10","d":"M20.4,16.8 C22,15.2,23,13.2,23,11c0-5-4.9-9-11-9S1,6,1,11c0,5,4.9,9,11,9c1.1,0,2.1-0.1,3.1-0.4L21,22L20.4,16.8z","key":0}),React.createElement("line",{"data-color":"color-2","fill":"none","strokeMiterlimit":"10","x1":"8","y1":"9","x2":"16","y2":"9","key":1}),React.createElement("line",{"data-color":"color-2","fill":"none","strokeMiterlimit":"10","x1":"8","y1":"13","x2":"13","y2":"13","key":2})])]);
}

Inbox.defaultProps = {"viewBox":"0 0 24 24","width":"24","height":"24"};

module.exports = Inbox;

Inbox.default = Inbox;
